import { palette } from './palette';
import { PaletteOptions } from '@mui/material/styles';

export const lightPaletteBlockRail = {
  ...palette,

  mode: 'light',

  primary: {
    ...palette.primary,
    main: palette.indigo.main, // 356DF3 => 5856D6
    dark: palette.indigo.dark, // 2A5BD1 => 4B49B6
  },

  secondary: {
    ...palette.secondary,
    dark: '#8F8F97 ', // E7EBF3 => #8F8F97
    light: '#8F8F97 ', // E7EBF3 => #8F8F97
  },

  info: {
    ...palette.info,
    dark: '#8F8F97', // E7EBF3 => #8F8F97
    light: '#8F8F97', // E7EBF3 => #8F8F97
    contrastText: palette.indigo.main, // 356DF3 => 5856D6
  },

  background: {
    ...palette.background,
    default: '#F0F1F2', // F2F5FA => F0F1F2
  },

  grey: {
    100: '#F0F1F2', // '#E7EBF3' => 'F0F1F2',
    200: '#E4E6E8', // '#DFE3EB' => 'E4E6E8',
    300: '#D7D8D9', // '#BFC6D0' => 'D7D8D9',
    400: '#C9CCD1', // '#A7AFC0' => 'C9CCD1',
    500: '#999999', // '#9AA1B0' => '999999',
    600: '#929395', // '#82899A' => '929395',
    700: '#8F8F97', // '#585E6B' => '8F8F97',
    800: '#6C6C6C', // '#2E343C' => '6C6C6C',
    900: '#333333', // '#1F2226' => '333333',
  },

  link: {
    main: palette.indigo.main,
  }
} satisfies PaletteOptions;
